import { Colors } from "../../../palettes/colorPalette";
import bumpMap from "../snippets/bumpMap";
import highLowEncoding from "../snippets/highLowEncoding";
import phongLightingWithRimLight from "../snippets/phongLightingWithRimLight";

export default `
precision highp float;

uniform sampler2D uSampler;
uniform sampler2D uDepthSampler;
uniform vec2 texelSize;
uniform vec4 backgroundColorLight;
uniform vec4 backgroundColorDark;
uniform vec4 virusTrailColor;

uniform sampler2D uTrailsTexture;
uniform float trailUvScaler;
uniform vec2 trailUvOffset;

varying vec2 vTextureCoord;

${bumpMap('uDepthSampler', '0.5')}
${highLowEncoding()}
${phongLightingWithRimLight()}

void main() {
	vec4 depth4 = texture2D(uDepthSampler, vTextureCoord);
	float depth = depth4.r;
	float bgColorFade = depth4.b;


	//Don't do the seperation thing if we havent set it in the palette.
	${(Colors.BackgroundColorSeperation > 0 && Colors.BackgroundColorSeperation !== 1) ?
		`
		float exagerate = float(${Colors.BackgroundColorSeperation});
		bgColorFade =  (bgColorFade * exagerate);
		bgColorFade = pow(bgColorFade, exagerate);
		bgColorFade /= exagerate;
	` : ``}

	vec4 shadedBackgroundColor = mix(backgroundColorLight, backgroundColorDark, bgColorFade);

	vec2 imprintUv = (vTextureCoord + trailUvOffset) * (trailUvScaler);
	vec4 trailColor = texture2D(uTrailsTexture, imprintUv);
	float virusTrail = trailColor.r * highLowDecode(trailColor.gb) * insideUv(imprintUv);

	shadedBackgroundColor = mix(shadedBackgroundColor, virusTrailColor, virusTrail);

	vec4 color = texture2D(uSampler, vTextureCoord);
	color = mix(shadedBackgroundColor, color, color.a);
    
	//Bump map normals
	vec3 normal = bumpFromDepth(vTextureCoord, depth, 10.0, texelSize.x);

	//Light setup
	vec2 worldUv = vTextureCoord * 2.0 - 1.0;
	vec2 lightPos = vec2(1920.0/2.0, -720.0); //was uniform, but override to get around bug
	vec3 lightPosition = vec3(lightPos, 1000); //need a z-dimension for the lighting in "pixels"

	LightingInfo lighting = phongLighting(worldUv, normal, lightPosition, color);
	vec3 result = lighting.litColor;

	gl_FragColor = vec4(result, 1.0);
	//gl_FragColor = color;
}`;